import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { propNumber, propShape } from '../../../../helpers/custom-prop-types';
import SplitText from '../../../Ui/Common/SplitText';
const SolutionTabDescriptionOptions = (props) => {
    const { currentIndex, item, tabIndex } = props;
    if (tabIndex !== currentIndex) {
        return null;
    }
    return (_jsxs("div", Object.assign({ className: 'tab-content' }, { children: [_jsx("h2", { children: "\u6210\u679C\u7269" }), _jsx(SplitText, { text: item.artifactsDescription }), item.options.length > 0 && (_jsxs(_Fragment, { children: [_jsx("h2", Object.assign({ className: 'mt3' }, { children: "\u30AA\u30D7\u30B7\u30E7\u30F3" })), _jsx("ul", Object.assign({ className: 'b-options' }, { children: item.options.map(({ id, name, price }) => (_jsxs("li", { children: [name, _jsx("span", Object.assign({ className: 'ml10' }, { children: parseInt(price, 10) ? `${price}万円` : '金額は要相談' }))] }, id))) }))] }))] })));
};
SolutionTabDescriptionOptions.propTypes = {
    currentIndex: propNumber().isRequired,
    item: propShape().isRequired,
    tabIndex: propNumber().isRequired,
};
export default SolutionTabDescriptionOptions;
